// src/App.js
import React from 'react';
import JobList from './JobList';
import PageTitle from '../../../layouts/PageTitle';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const JHAJobs = () => {
    return (
        <>
            <PageTitle pageTitle={"JHA Job Settings"} />
            <Card >
                <Row>
                    <Col>
                        <h2 style={{color:"black"}}>JHA Job Details</h2>
                    </Col>
                    <Col>
                        <div className="d-flex justify-content-end">
                            <Link to={'/settings/jha-setting/add'} title='Add' className="btn btn-primary shadow sharp me-1">
                                Add <i className="fa fa-plus"></i>
                            </Link>
                        </div>
                    </Col>
                </Row>

                <JobList />
            </Card>
        </>
    );
};

export default JHAJobs;
